<template>
	<div class="collectGroup">
		<el-form-item
			:label="item.label"
			:prop="`${item.field}`"
			:hidden="item.options.hidden"
			v-if="item.showed"
			:rules="[
				{
					required: item.required || false,
					message: item.label + '为必填字段',
				},
			]"
		>
			<el-radio-group v-model="radioVal" @change="radioChange">
				<el-radio v-for="(radio, index) in item.options.valueData" :key="index" :label="radio.code" :disabled="item.options.disabled">{{ radio.label }}</el-radio>
			</el-radio-group>
		</el-form-item>
		<template v-for="(child, index) of childList">
			<el-form-item
				label="报告类型"
				v-if="child.label == '报告类型'"
				:key="index"
				:rules="[
					{
						required: child.required || false,
						message: child.label + '为必填字段',
						trigger: 'change',
					},
				]"
			>
				<el-radio-group v-model="reportType" @change="val => radioChange1(val, child.field, child.options.valueData)">
					<template v-for="(op, i) of child.options.valueData">
						<el-radio :label="op.code" v-if="op.label == '电子'" :key="i" :disabled="item.options.disabled">{{ op.label }}</el-radio>
						<el-radio :label="op.code" v-if="op.label == '纸质' && radioVal == 'BGXS_ZSBG'" :key="i" :disabled="item.options.disabled">{{ op.label }}</el-radio>
					</template>
				</el-radio-group>
			</el-form-item>
			<el-form-item
				label="报告领取"
				v-if="child.label == '报告领取'"
				:key="index"
				:rules="[
					{
						required: child.required || false,
						message: child.label + '为必填字段',
					},
				]"
			>
				<el-radio-group v-model="reportGet" @change="val => radioChange2(val, child.field, child.options.valueData)">
					<template v-for="(op, i) of child.options.valueData">
						<el-radio :label="op.code" v-if="op.label == '自领' && reportType == 'BGLX_ZZ'" :key="i" :disabled="item.options.disabled">{{ op.label }}</el-radio>
						<el-radio :label="op.code" v-if="op.label == '邮寄' && reportType == 'BGLX_ZZ'" :key="i" :disabled="item.options.disabled">{{ op.label }}</el-radio>
						<el-radio :label="op.code" v-if="op.label == 'Email' && reportType == 'BGLX_DZ'" :key="i" :disabled="item.options.disabled">{{ op.label }}</el-radio>
					</template>
				</el-radio-group>
			</el-form-item>
			<template v-if="reportGet == 'DDLQ_YJ'">
				<el-form-item
					label="邮寄地址"
					:prop="`${child.field}`"
					v-if="child.label == '邮寄地址'"
					:key="index"
					:rules="[
						{
							required: child.required || false,
							message: child.label + '为必填字段',
						},
					]"
				>
					<el-input v-model="$attrs.model[child.field]" :disabled="item.options.disabled"></el-input>
				</el-form-item>
				<el-form-item
					label="收件人"
					:prop="`${child.field}`"
					v-if="child.label == '收件人'"
					:key="index"
					:rules="[
						{
							required: child.required || false,
							message: child.label + '为必填字段',
						},
					]"
				>
					<el-input v-model="$attrs.model[child.field]" :disabled="item.options.disabled"></el-input>
				</el-form-item>
				<el-form-item
					label="联系方式"
					:prop="`${child.field}`"
					v-if="child.label == '联系方式'"
					:key="index"
					:rules="[
						{
							required: child.required || false,
							message: child.label + '为必填字段',
						},
					]"
				>
					<el-input v-model="$attrs.model[child.field]" :disabled="item.options.disabled"></el-input>
				</el-form-item>
			</template>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		item: Object,
	},
	data() {
		return {
			radioVal: '',
			reportType: '',
			reportGet: '',
			postAddr: '',
			consignee: '',
			phone: '',
			childList: this.item.childrenList,
			yjshow: false,
		}
	},
	created() {
		console.log(this.$attrs.model[this.item.field])
		this.init()
	},
	methods: {
		init() {
			if (this.$attrs.model[this.item.field]) {
				this.radioVal = this.$attrs.model[this.item.field]
			}
			for (var i = 0; i < this.childList.length; i++) {
				if (this.childList[i].label == '报告类型') {
					this.reportType = this.childList[i]['val']
				}
				if (this.childList[i].label == '报告领取') {
					this.reportGet = this.childList[i]['val']
				}
			}
		},
		// 点击报告形式
		radioChange(val) {
			this.$set(this.$attrs.model, this.item.field, val)
			if (val == 'BGXS_JCSJ') {
				//报告形式-检测数据
				this.reportType = 'BGLX_DZ'
				this.reportGet = 'DDLQ_DY'
				for (var i = 0; i < this.childList.length; i++) {
					if (this.childList[i].label == '报告类型') {
						this.$set(this.$attrs.model, this.childList[i]['field'], 'BGLX_DZ')
					}
					if (this.childList[i].label == '报告领取') {
						this.$set(this.$attrs.model, this.childList[i]['field'], 'DDLQ_DY')
					}
				}
			}
		},
		// 点击报告类型
		radioChange1(val, field, valueData) {
			console.log(val, 'valvalvalval')
			console.log(valueData, 'valueDatavalueData')
			if (val == 'BGLX_ZZ') {
				//报告类型-纸质
				this.reportGet = 'DDLQ_ZQ'
				for (var i = 0; i < this.childList.length; i++) {
					if (this.childList[i].label == '报告领取') {
						this.$set(this.$attrs.model, this.childList[i]['field'], 'DDLQ_ZQ')
					}
				}
			} else {
				this.reportGet = 'DDLQ_DY'
				for (var m = 0; m < this.childList.length; m++) {
					if (this.childList[m].label == '报告领取') {
						this.$set(this.$attrs.model, this.childList[m]['field'], 'DDLQ_DY')
					}
				}
			}
			this.$set(this.$attrs.model, field, val)
		},
		// 点击报告领取
		radioChange2(val, field, valueData) {
			console.log(valueData, '2222valueData')
			this.$set(this.$attrs.model, field, val)
		},
	},
}
</script>

<style lang="scss" scoped></style>
